import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MfaValidateDetails, Organization, SignupInfo, User } from "../../types/user.types";
import { PROFILE_STATUS } from "@/utils/constant/global.constant";

interface LoginState {
  currentUser: null | undefined | User;
  currentOrg: null | undefined | Organization;
  mfaValidateDetails: MfaValidateDetails | null;
  signupInfo: SignupInfo | null;
  orgs: null | Organization[];
}

const initialState: LoginState = {
  currentUser: undefined,
  orgs: null,
  currentOrg: undefined,
  mfaValidateDetails: null,
  signupInfo: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<{ user: User | null; orgs: Organization[] | null; perms?: string[] | null }>) => {
      if (action.payload.user) {
        state.currentUser = { ...action.payload.user, perms: action.payload.perms || [] } as User;
      } else {
        state.currentUser = action.payload.user;
      }
      if (action.payload.orgs) {
        state.orgs = action.payload.orgs;
        state.currentOrg = action.payload.orgs[0];
      }
    },
    resetIsTempPass: (state) => {
      if (state.currentUser) {
        state.currentUser.isTempPass = "";
      }
    },
    setCurrentOrg: (state, action: PayloadAction<Organization>) => {
      state.currentOrg = action.payload as any;
    },
    setValidateMfaDetails: (state, action: PayloadAction<MfaValidateDetails>) => {
      state.mfaValidateDetails = action.payload as any;
    },
    setSignupInfo: (state, action: PayloadAction<SignupInfo>) => {
      state.signupInfo = action.payload;
    },
    setLogout: () => {
      return { ...initialState, currentUser: null };
    },
  },
});

export const { setUserInfo, setLogout, setValidateMfaDetails, setSignupInfo, resetIsTempPass } = loginSlice.actions;

// selectors
export const loginSelector = (state: any) => state.login as LoginState;

export default loginSlice.reducer;

export const isOrgPending = (state: any) => {
  const currentOrg = (state.login as LoginState).currentOrg;
  return currentOrg?.SignupOrg?.acc_sts_id !== PROFILE_STATUS["PRFL-CMTD"];
};
